export default __webpack_public_path__ + "static/media/gettyimages-855413388-612x612.500f5537.jpg";